import { render, staticRenderFns } from "./per.vue?vue&type=template&id=f2e80858&"
import script from "./per.vue?vue&type=script&lang=js&"
export * from "./per.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports